import type { AccountResult, AccountState, VirtualAccountSummary } from '@pnl/shared';

type Tone = 'success' | 'warning' | 'danger' | 'neutral';

/**
 * Resultado derivado → rótulo + tom do StatusBadge (estilo FTMO). Quando a conta
 * está em andamento, o rótulo reflete a fase: Funded/Live em vez de "Em andamento".
 */
export function resultBadge(
  result: AccountResult,
  phase?: VirtualAccountSummary['phase'],
): { label: string; tone: Tone } {
  switch (result) {
    case 'IN_PROGRESS':
      if (phase === 'FUNDED') return { label: 'Funded', tone: 'success' };
      if (phase === 'LIVE') return { label: 'Live', tone: 'success' };
      return { label: 'Em andamento', tone: 'success' };
    case 'NOT_APPROVED':
      return { label: 'Não aprovado', tone: 'danger' };
    case 'BLOWN':
      return { label: 'Encerrada', tone: 'danger' };
    case 'CLOSED':
    default:
      return { label: 'Encerrada', tone: 'neutral' };
  }
}

/** Estado derivado → rótulo (Ativo / Terminado). */
export function stateLabel(state: AccountState): string {
  return state === 'ACTIVE' ? 'Ativo' : 'Terminado';
}
